/* eslint-disable max-len */

import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import template from "./ns-promo-band.html";

import "@nuskin/ns-style-elements";

/**
 * The ns-promo-band should be used for
 *
 * <h1>promo-band</h1>
 * <demo-snippet class="demoSnippet">
 *   <template>
 *     <ns-promo-band class="demoElement"></ns-promo-band>
 *   </template>
 * </demo-snippet>
 *
 */
class NsPromoBand extends PolymerElement {
  constructor() {
    super();
  }

  ready() {
    super.ready();
  }

  static get is() {
    return "ns-promo-band";
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get properties() {
    return {
      associatedColor: {
        type: String,
        value: "#009660"
      },
      copyBottom: {
        type: String,
        value: "Copy Bottom"
      },
      copyTop: {
        type: String,
        value: "Copy Top"
      },
      href: {
        type: String,
        value: "https://www.nuskin.com"
      },
      lineOne: {
        type: String,
        value: "h2-thin",
        reflectToAttribute: true
      },
      lineTwo: {
        type: String,
        value: "h2-bold-italic",
        reflectToAttribute: true
      },
      texture: {
        type: String,
        value:
          "http://www.wildtextures.com/wp-content/uploads/2012/01/wildtextures-creased-black-paper-texture.jpg"
      }
    };
  }
}
customElements.define(NsPromoBand.is, NsPromoBand);
